var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',[_c(_setup.StartupEditField,{attrs:{"field-name":"facebookUrl","label":"Facebook"}}),_c(_setup.StartupEditField,{attrs:{"field-name":"twitterUrl","label":"Twitter"}}),_c(_setup.StartupEditField,{attrs:{"field-name":"linkedinUrl","label":"LinkedIn"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }